import random from 'toxilibs/random.js'
import Vector from 'toxilibs/vector.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: 'vector_from_points',
    dependencies: [
        'levels_maths/vector',
        'levels_maths/substraction'
    ]
})


function pointA (rangeX, rangeY) {
    return new Vector(
        random.fairChoiceInt(rangeX[0], rangeX[1], {name: 'ax'}),
        random.fairChoiceInt(rangeY[0], rangeY[1], {name: 'ay'})
    )
}


function vectorV (rangeX, rangeY) {
    return new Vector(
        random.fairChoiceInt(rangeX[0], rangeX[1], {name: 'vx'}),
        random.fairChoiceInt(rangeY[0], rangeY[1], {name: 'vy'})
    )
}


function common (q, {a, v, noScreen, noAxes, noGrid, inverted, noVectorName, noCoordsInQuestion}) {

    a.name  = 'A'
    a.color = '#F00'

    let b = a.plus(v)
    b.name  = 'B'
    b.color = '#F00'

    v.name = 'AB'

    if (inverted) {
        v.multiply$(-1)
        v.name = 'BA'
    }

    v.color = '#F00'

    if (!noScreen) {
        let geoScreen = q.addGeoScreen({noAxes, noGrid})

        let geoParam
        if (inverted) {
            geoParam = {
                start: b,
                end:   a
            }
        } else {
            geoParam = {
                start: a,
                end:   b
            }
        }

        if (!noVectorName) {
            geoParam.name = v.name
        }

        geoScreen.addVectorWithPoints(geoParam)

    }

    if (!noCoordsInQuestion) {
        q.addText(mathText.point(a))
        q.addText(mathText.point(b))
    }

    q.addText(mathText.vectorName(v) + '( ? )')
    q.answer = v.x + ';' + v.y

}


level.addQuestion({
    generator: function (q) {
        common(q, {
            a: pointA([0, 5], [0, 3]),
            v: vectorV([1, 5], [1, 5]),
            noAxes: true,
            noCoordsInQuestion: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            a: pointA([-3, 5], [-4, 2]),
            v: vectorV([-4, 1], [1, 4]),
            noCoordsInQuestion: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            a: pointA([-3, 5], [-4, 2]),
            v: vectorV([-4, 1], [1, 4]),
            inverted: true,
            noCoordsInQuestion: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            a: pointA([0, 5], [0, 3]),
            v: vectorV([1, 5], [1, 5])
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            a: new Vector(10, 10),
            v: vectorV([1, 5], [1, 5]),
            noGrid: true,
            noVectorName: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            a: pointA([1, 5], [1, 5]),
            v: vectorV([1, 5], [1, 5]),
            noGrid: true,
            noVectorName: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            a: pointA([-4, 2], [-4, 4]),
            v: vectorV([1, 4], [-4, 4]),
            noGrid: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            a: pointA([0, 4], [0, 4]),
            v: vectorV([1, 5], [1, 5]),
            inverted: true,
            noGrid: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            a: pointA([1, 4], [1, 4]),
            v: vectorV([1, 4], [1, 4]),
            noScreen: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            a: pointA([-1, 6], [-1, 6]),
            v: vectorV([-5, -1], [-5, 5]),
            noScreen: true
        })
    }
})


export default level

